import dayjs, { Dayjs } from "utils/dayjs"
import i18n from "intl/i18n"

import { ApiLinkEntity, ApiLinkRel } from "config/constants"
import { Guid, IApiLink } from "@/types"
import { toDateWithoutTimezone } from "utils/utils"

export interface IGetDowntimePeriodDto {
    id: Guid
    description: string
    start: string
    end: string
    discount: number
    excludedInvoicePositions?: string[] | null
    links?: IApiLink[]
}

export interface ICreateUpdateDowntimePeriodDto {
    description: string
    start: string
    end: string
    discount: number
    excludedInvoicePositions?: string[] | null
}

export interface ICreateUpdateDowntimePeriod extends Omit<ICreateUpdateDowntimePeriodDto, 'start' | 'end'> {
    start: Dayjs
    end: Dayjs
}

export default class DowntimePeriod {
    id: Guid
    description: string
    start: Dayjs
    end: Dayjs
    discount: number
    excludedInvoicePositions: string[]

    linkUpdate?: IApiLink
    linkDelete?: IApiLink

    constructor(dto: IGetDowntimePeriodDto) {
        this.id = dto.id
        this.description = dto.description
        this.start = dayjs.utc(dto.start, "YYYY-MM-DD") // take only date ignoring the time
        this.end = dayjs.utc(dto.end, "YYYY-MM-DD") // take only date ignoring the time
        this.discount = dto.discount
        this.excludedInvoicePositions = dto.excludedInvoicePositions || []
        this.linkUpdate = dto.links?.find(lnk => lnk.rel === ApiLinkRel.update && lnk.entity === ApiLinkEntity.downtimePeriod)
        this.linkDelete = dto.links?.find(lnk => lnk.rel === ApiLinkRel.delete && lnk.entity === ApiLinkEntity.downtimePeriod)
    }

    static getCreateUpdateDto(data: ICreateUpdateDowntimePeriod): ICreateUpdateDowntimePeriodDto {
        return {
            description: data.description,
            start: toDateWithoutTimezone(data.start),
            end: toDateWithoutTimezone(data.end),
            discount: data.discount,
            excludedInvoicePositions: data.excludedInvoicePositions
        }
    }

    printDates() {
        return `${this.start.format(i18n.t('config.dateLongFormat'))} – ${this.end.format(i18n.t('config.dateLongFormat'))}`
    }
}
